import React from "react";
import "./ContactEmail.scss";
// import {Link} from "react-router-dom";
// import { ReactComponent as SideBtn } from "../../assets/svg/side-btn.svg";

const ContactEmail = () => {
  return (
    <section className="section contactEmail">
      <article className="contactEmail__container container">
        <div className="contactEmail__container--title">
          <h3>
            Feel free to reach out via email to discuss potential business
            collaborations or explore career opportunities with us.{" "}
            <span>
              <br />
              <br />
              We look forward to hearing from you..
            </span>
          </h3>
        </div>

        <div className="contactEmail__container--links">
          <div className="contactEmail__links--wrapper">
            <div className="contactEmail__links">
              <h3>info@radiksez.com</h3>
              <p>Projects, collaborations and queries.</p>
            </div>

            {/* <div className="contactEmail__links">
              <h3>careers@radiksez.com</h3>
              <p>Join our dynamic Team</p>
            </div> */}
          </div>

          {/* <Link href="/careers" className="contactEmail__links-btn">
            <button className="links__btn">
              <span>View open positions</span>
            </button>
            <SideBtn />
          </Link> */}
        </div>
      </article>
    </section>
  );
};

export default ContactEmail;
